import { ApiService } from '../../app-lite/api/api.service';

import VehicleVisualsSettingsHtml from './vehicle-visuals.settings.html';

export function VehicleVisualsStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'VehicleVisualsCtrl',
    name       : 'app.vehicle-visuals-settings',
    templateUrl: VehicleVisualsSettingsHtml,
    url        : '/vehicle_visuals_settings',
    resolve    : {
      settings: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company')
    }
  });
}